export interface RegisterSystemUserRequest {
  userId: string
  passwordExpirationDate: string
  name: string
  isActive: boolean
  groupId: number
  authFailureLimitCount: number
  note: string
}

export function RegisterSystemUserRequestToJSON(
  value: RegisterSystemUserRequest
): any {
  return {
    user_id: value.userId !== '' ? value.userId : undefined,
    password_expiration_date:
      value.passwordExpirationDate !== ''
        ? value.passwordExpirationDate
        : undefined,
    name: value.name !== '' ? value.name : undefined,
    is_active: value.isActive ?? undefined,
    group_id: value.groupId !== 0 ? value.groupId : undefined,
    auth_failure_limit_count:
      value.authFailureLimitCount !== 0
        ? value.authFailureLimitCount
        : undefined,
    note: value.note !== '' ? value.note : undefined
  }
}
